// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"74":"About","384":"workstudyplus-parent","784":"Logins"}[chunkId] || chunkId) + "-legacy." + {"74":"32ea08ae","384":"0416be35","552":"a04a721f","727":"2071be73","761":"a7ff124a","784":"a30db209","889":"283adb37","890":"87c733d7"}[chunkId] + ".js";
};